module.exports = __webpack_public_path__ + "img/1495597572.7802fcda.jpg";